var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoofCareViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hoof_care_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.97,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hoof_care_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.46.33a17,17,0,0,0-17,16.88V428.05a17,17,0,0,0,17,16.88H584.34a17,17,0,0,0,17-16.88V17.21a17,17,0,0,0-17-16.88",
    fill: "#ff7336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.39,
    y: 76.48,
    width: 380.92,
    height: 444.6,
    rx: 16.79,
    fill: "#ffa068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.56,270.54V582.29c0,9.24-7.73,16.71-17.26,16.71H19.89A17,17,0,0,1,2.64,582.29V171.12a17,17,0,0,1,17.25-16.71H263.68a18,18,0,0,1,5.85,1L382,263.62A16.28,16.28,0,0,1,383.56,270.54Z",
    fill: "#ffe5dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,262.61h-95a17.2,17.2,0,0,1-17.43-17V154.39Z",
    fill: "#ff7336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.05,
    y: 371.09,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.93 1.43) rotate(-0.43)",
    fill: "#ff7b39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.17,
    y: 516.67,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.03 0.96) rotate(-0.43)",
    fill: "#ff7b39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.49,
    y: 298.53,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.38 1.42) rotate(-0.43)",
    fill: "#ff7b39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.61,
    y: 443.64,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.48 1.43) rotate(-0.43)",
    fill: "#ff7b39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoofCareViewEntries);
export default __webpack_public_path__ + "static/media/hoof_care_view_entries.3b2ccdd3a364bc0599b1ad2abb57fe73.svg";
export { ForwardRef as ReactComponent };